import { render, staticRenderFns } from "./MenuSubModule.vue?vue&type=template&id=4ecfce84&scoped=true&"
import script from "./MenuSubModule.vue?vue&type=script&lang=js&"
export * from "./MenuSubModule.vue?vue&type=script&lang=js&"
import style0 from "./MenuSubModule.vue?vue&type=style&index=0&id=4ecfce84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecfce84",
  null
  
)

export default component.exports